import angular from 'angular';

import EditStudentAccountController from './edit-student-account-controller';

const editStudentAccount = angular.module('editStudentAccount', []);
editStudentAccount.controller('EditStudentAccountController', EditStudentAccountController);

export default editStudentAccount.name;
